module.exports = __webpack_public_path__ + "static/media/no.51a7ba8c.svg";